import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedMaterials: {},
      sizesSKUs: ["VELKOST", "SIZE", "VELIKOST", "ROZMIAR"],
      result: {},
      isInitialized: false,
      localProduct: null,
      isUserInteraction: false,
    };
  },
  computed: {
    ...mapGetters({
      getMaterialsCategories: "general/getMaterialsCategories",
    }),
    filteredMaterialsByCategories() {
      const product = this.localProduct || this.productData;
      if (!product || !product.product_material_categories) {
        return [];
      }
      const materialsByCategories =
        product.product_material_categories?.reduce((acc, el) => {
          const currentCategory = this.getMaterialsCategories?.find(
            (it) => it.id === el.id
          );

          if (currentCategory) {
            acc.push({
              ...currentCategory,
              sku_enabled: el.sku_enabled,
              materials: product.product_materials?.reduce(
                (acc, material) => {
                  if (material.material_category_id === currentCategory.id) {
                    acc.push({
                      ...material,
                    });
                  }
                  return acc;
                },
                []
              ),
            });
          }
          return acc;
        }, []);
      return materialsByCategories.filter((item) => {
        return item.materials && item.materials.length > 0;
      });
    },
    ringSizeMaterialCategory() {
      const category = this.filteredMaterialsByCategories.find((el) =>
        this.sizesSKUs.includes(el?.sku)
      ) || null;
      return category;
    },
    ringSizeSelectedItem() {
      if (!this.ringSizeMaterialCategory) return null;
      return (
        this.result[this.ringSizeMaterialCategory?.slug] ||
        this.selectedMaterials[this.ringSizeMaterialCategory?.slug] ||
        null
      );
    },
    currentSku() {
      if (!Object.keys(this.result).length) {
        return null;
      }

      const newSku = Object.values(this.result).reduce((acc, el) => {
        return acc + "-" + el.sku;
      }, (this.localProduct || this.productData)?.vendor_model);

      return newSku;
    },
  },
  methods: {
    handleFilter(event) {
      if (event && event.slug && event.item) {
        this.isUserInteraction = true;
        
        const category = this.filteredMaterialsByCategories.find(
          (cat) => cat.slug === event.slug
        );
        
        const isInResult = Object.hasOwn(this.result, event.slug);
        
        if (isInResult) {
          this.onFilterClick(event, category);
        } else {
          this.onOptionsFilterClick(event, category);
        }
      }
    },
    onFilterClick(event, category) {
      if (!event || !event.item) {
        return;
      }
      
      this.result = { ...this.result, [event.slug]: event.item };
      
      if (!this.isUserInteraction) {
        return;
      }
      
      if (!category || category.sku_enabled !== 1) {
        return;
      }
      
      const isRingSize = this.sizesSKUs.includes(event.item?.material_category_sku || "");
      
      let newSku;
      const product = this.localProduct || this.productData;
      if (isRingSize) {
        const defaultSku = product?.default_sku || product?.vendor_model || "";
        const skuParts = defaultSku.split("-");
        if (skuParts.length > 1) {
          skuParts[skuParts.length - 1] = event.item.sku;
        }
        newSku = skuParts.join("-");
      } else {
        newSku = Object.values(this.result).reduce((acc, el) => {
          return acc + "-" + el.sku;
        }, product?.vendor_model);
      }
      
      this.updateConfiguration(newSku);
    },
    onOptionsFilterClick(event, category) {
      if (!event || !event.item) {
        return;
      }
      
      this.selectedMaterials = { ...this.selectedMaterials, [event.slug]: event.item };
      
      if (!this.isUserInteraction) {
        return;
      }
      
      if (!category || category.sku_enabled !== 1) {
        return;
      }
      
      const product = this.localProduct || this.productData;
      const defaultSku = product?.default_sku || product?.vendor_model || "";
      const skuParts = defaultSku.split("-");
      
      if (skuParts.length > 1) {
        skuParts[skuParts.length - 1] = event.item.sku;
      }
      
      const newSku = skuParts.join("-");
      
      this.updateConfiguration(newSku);
    },
    setMaterials() {
      const result = {};
      const additionalOptions = {};
      
      this.filteredMaterialsByCategories.forEach((category) => {
        if (category.sku_enabled && category.materials && category.materials.length > 0) {
          result[category.slug] = category.materials[0];
        } else if (category.materials && category.materials.length > 0) {
          additionalOptions[category.slug] = category.materials[0];
        }
      });
      
      this.result = result;
      this.selectedMaterials = additionalOptions;
      this.isInitialized = true;
    },
    async updateConfiguration(sku) {
      const skuToUse = sku || this.currentSku;
      
      if (!skuToUse) {
        return;
      }
      
      try {
        const response = await this.$api.products.getConfiguration(skuToUse);

        if (response && response.data && response.data.data) {
          const configInfo = response.data.data;

          this.localProduct = {
            ...this.localProduct,
            default_sku: configInfo.configuration_id,
            productSKU: configInfo.configuration_id,
            ...(configInfo.cost && {
              cost: configInfo.cost,
              base_cost: configInfo.cost,
            }),
            ...(configInfo.materials && { materials: configInfo.materials }),
            ...(configInfo.translations && { translations: configInfo.translations }),
          };
          
          if (configInfo.medias && configInfo.medias.length > 0) {
            const plpImage = configInfo.medias.find((img) => img.position === "PLP");
            
            if (plpImage && plpImage.file) {
              this.localProduct = {
                ...this.localProduct,
                variant_plp_image: {
                  ...this.localProduct.variant_plp_image,
                  image: {
                    ...plpImage.file,
                  },
                },
              };
            }
          }
        }
      } catch (error) {
      }
    },
  },
};

